var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcApp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.5,10.5 H7 C5.1,10.5 3.5,8.9 3.5,7 C3.5,5.1 5.1,3.5 7,3.5 C8.9,3.5 10.5,5.1 10.5,7 V10.5 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5,10.5 V7 C13.5,5.1 15.1,3.5 17,3.5 C18.9,3.5 20.5,5.1 20.5,7 C20.5,8.9 18.9,10.5 17,10.5 H13.5 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5,13.5 V17 C10.5,18.9 8.9,20.5 7,20.5 C5.1,20.5 3.5,18.9 3.5,17 C3.5,15.1 5.1,13.5 7,13.5 H10.5 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5,13.5 H17 C18.9,13.5 20.5,15.1 20.5,17 C20.5,18.9 18.9,20.5 17,20.5 C15.1,20.5 13.5,18.9 13.5,17 V13.5 Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcApp);
export default __webpack_public_path__ + "static/media/ic_app.20dc5c7f34b1488ba46fbdce1e220cbe.svg";
export { ForwardRef as ReactComponent };